import React from 'react';

import { PlainReferenceChip } from './PlainReferenceChip';
import type { ReferenceTriggerProps } from './referenceKinds';

/**
 * A cited calculation, whose id is the checked expression itself (`12400-1000=11400`): a chip with the result
 * after the last `=`, and the whole expression on hover. An expression with no result keeps the sentence's own link
 * text.
 */
export const CalcReferenceTrigger: React.FC<ReferenceTriggerProps> = ({ reference, children }) => {
  const expression = String(reference.id);
  const result = expression.slice(expression.lastIndexOf('=') + 1);

  return <PlainReferenceChip label={result || children} body={expression} />;
};
